export const ADD_ERROR = Symbol();
export const REMOVE_ERROR = Symbol();
export const RECOVER_ERROR = Symbol();
export const CLEAR_ERRORS = Symbol();
